import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppFieldBox, AppGroup, AppRow } from 'components/appComponents';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox } from 'devextreme-react';

import {
  useChangeMaterialPriceMutation,
  useCreateMaterialPriceMutation,
  useLazyGetMaterialPriceDetailQuery,
} from 'bus/materialPrice/services/services';
import { MaterialPrice } from 'bus/materialPrice/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  materialId: number | null;
};

const initialForm: MaterialPrice = {
  price: 0,
  dateBegin: new Date(),
  nomenclatureId: null,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, materialId, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<MaterialPrice>(initialForm);

  const [getDetail] = useLazyGetMaterialPriceDetailQuery();
  const [create, { isLoading: isLoadingCreate }] = useCreateMaterialPriceMutation();
  const [change, { isLoading: isLoadingChange }] = useChangeMaterialPriceMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await getDetail({ id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await change({ ...form, id });
      } else {
        await create({ ...form, nomenclatureId: materialId! });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Материал"
        width={350}
        minHeight="auto"
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFieldBox label="Стоимость" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format="###0.##"
                            value={form.price}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, price: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Стоимость" />
                            </Validator>
                          </NumberBox>
                        </AppFieldBox>
                        <AppFieldBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата" />
                            </Validator>
                          </DateBox>
                        </AppFieldBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
